<template>
  <div>
    <b-card
      no-body
      v-if="hasData"
    >
      <b-row class="mx-1 mt-1">
        <b-card
          class="header-card"
        >
          <h4 class="mb-1">Device Details</h4>
          <div class="details-row d-flex flex-row mt-2">
            <span>
              <b-icon :style="{ color: iconColors.teal}" class="mr-0-5" icon="info-square-fill"/>
              <b>Device Name:</b>
              {{ rowInfo.hostName ? rowInfo.hostName : 'N/A' }}
            </span>
            <span>
              <b-icon :style="{ color: iconColors.blue}" class="mr-0-5" icon="grid-fill"/>
              <b>OS Type:</b>
              {{ rowInfo.osType ? rowInfo.osType : 'N/A' }}
            </span>
          </div>
        </b-card>
      </b-row>
      <b-row>
        <b-col>
          <div
            class="px-2"
          >
            <b-table
              striped
              outlined
              :items="dataFilter"
              :fields="computedTableFields"
              :per-page="10"
              :currentPage="currentPage"
            />
            <b-pagination
              v-model="currentPage"
              :total-rows="paginationDataRows"
              :per-page="10"
              align="right"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-2"
            />
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      v-else-if="loaded"
    >
      {{ $t("No Device Details Data Available") }}
    </b-card>
  </div>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import colorPaletteShade from '@/xvisor/constants/colorPaletteShade';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    rowInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      data: [],
      iconColors: {
        teal: colorPalette.teal,
        blue: colorPaletteShade.blue6,
      },
      deviceDetails: [],
      currentPage: 1,
      tableFields: [
        { key: 'processName', label: 'Process', sortable: true },
        { key: 'userName', label: 'Username', sortable: true },
        { key: 'executionCount', label: 'Execution Count', sortable: true },
      ],
      url: '/security/endpoint/devicedetails.json',
    };
  },
  computed: {
    hasData() {
      return this.data && this.data.length > 0;
    },
    dataFilter() {
      return this.data;
    },
    paginationDataRows() {
      return this.data.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    rowInfo() {
      this.httpGet();
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.currentPage = 1;
      this.data = [];
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
            devicename: this.rowInfo.hostName,
            ostype: this.rowInfo.osType,
          },
        })
        .then((response) => { this.data = response.data; })
        .finally(() => { this.loaded = true; });
    },
  },
};
</script>

<style scoped>
.header-card {
  width: 100%;
}
.header-card>.card-body {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.details-row {
  gap: 5rem;
}
</style>
